import { render } from "./commonLogin.vue?vue&type=template&id=b5c826d4&scoped=true&ts=true"
import script from "./commonLogin.vue?vue&type=script&lang=ts"
export * from "./commonLogin.vue?vue&type=script&lang=ts"

import "./commonLogin.vue?vue&type=style&index=0&id=b5c826d4&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5c826d4"]])

export default __exports__